'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _IconBase = require('./IconBase.js');

var _IconBase2 = _interopRequireDefault(_IconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PlotSankeyIcon = function PlotSankeyIcon(props) {
    return _react2.default.createElement(
        _IconBase2.default,
        _extends({ viewBox: '0 0 32 32' }, props),
        _react2.default.createElement('path', { d: 'M1.313 13.375v-.063h21.375v4l9.313-8-9.313-8v4H0V24c4.5 0 8.25 1.625 10.313 4.438l-1.875.75 6.25 2.813 2.813-6.25-2.063.75c-2.75-4.563-7.938-7.375-14.125-7.75v-.063c9.938.188 15.688 2.25 21.375 7.625l-1.563 1.5 6.875.188.188-6.875-1.563 1.5c-6.813-6.5-13.813-9.063-25.313-9.25z' })
    );
};

exports.default = PlotSankeyIcon;


//////////////////
// WEBPACK FOOTER
// ./node_modules/plotly-icons/lib/components/PlotSankeyIcon.js
// module id = 678
// module chunks = 0